import { ComponentType } from 'react';
import { Range, RangeProps } from 'rc-slider';
import { styles } from './styles';

// https://github.com/react-component/slider/issues/800
// https://github.com/react-component/slider/pull/782
const RCSliderRange = Range as unknown as ComponentType<RangeSliderProps>;

type RangeSliderProps = Omit<RangeProps, 'pushable'> & {
  pushable: number | boolean;
  disableMinChange?: boolean;
};

export default function RangeSlider({ pushable, ...props }: RangeSliderProps): JSX.Element {
  return (
    <div className={`slider-container ${props.disableMinChange ? 'disable-min-change' : ''}`}>
      <RCSliderRange
        allowCross={false}
        pushable={pushable}
        aria-hidden="true"
        {...props}
        value={props.disableMinChange ? [0, props.value?.[1] as number] : props.value}
      />
      <style jsx>{styles}</style>
    </div>
  );
}
